import Vue from 'vue';
import { errorHandler } from '@/services/errorHandler';

Vue.config.errorHandler = errorHandler;
